import { NotFoundError } from '@cian/peperrors/shared';
import { TFilterPikNewbuildingsResponse } from '../../../repositories/monolith-python/v1/filter-pik-newbuildings';

export const assertNotFoundError = (response: TFilterPikNewbuildingsResponse): void => {
  if (response.statusCode === 200) {
    return;
  }

  throw new NotFoundError({
    domain: 'src/shared/services/getFilteredResidentialComplexes/assert/assertNotFoundError.ts',
    message: 'Empty newbuilding data',
  });
};
